export const freeConveyancingService = {
  heading: 'free-conveyancing-srvc-heading',
  paragraph: 'free-conveyancing-srvc-paragraph',
  tableItem: 'free-convey-srvc-table-item',
  sectionName: 'free-convey-srvc-section',
  sectionNameInTable: 'free-convey-srvc-section-in-table',
};
